import React, {FC} from 'react';

/** 사용 가이드 「메인/상세 이미지 생성」 탭 한국어 본문(en.tsx와 요소 구조 1:1).
 * 프롬프트 없이 제품 사진/링크로 메인·상세 이미지를 만드는 과정(업로드 → AI 생성 → 스타일 선택 → 미리보기 → 다운로드)을 안내해요.
 * 2026-09-17 AI 번역. */
const KoContent: FC = () => {
  return (
    <>
      <h2>메인/상세 이미지 생성</h2>
      <p>
        프롬프트 없이 제품 사진을 업로드하거나 제품 링크를 붙여넣으면 AI가 플랫폼 사양에 맞는 메인 이미지, 보조 이미지,
        상세 페이지 전체 세트를 만들어 줘요. Amazon, Ozon, Coupang, Rakuten, Temu 등 주요 플랫폼을 지원해요.
      </p>

      <h3>1. 제품 사진 업로드 또는 제품 링크 붙여넣기</h3>
      <p>
        두 가지 입력 방식을 지원해요. 실제 제품 사진이나 흰 배경 이미지를 바로 업로드하거나, 제품 링크를 붙여넣으면
        시스템이 메인 이미지를 자동으로 캡처해 생성 소스로 사용해요.
      </p>

      <h3>2. AI가 제품을 인식하고 이미지 생성</h3>
      <p>
        AI가 제품을 자동으로 인식하고 장면을 구성하며 판매 포인트를 추출해 선택한 플랫폼 사양에 맞는 메인 이미지와 상세
        이미지를 생성해요. 이미지 종류마다 역할이 달라요:
      </p>
      <ul>
        <li>
          메인 이미지는 쇼핑객의 발걸음을 '멈추게' 하는 이미지예요. 검색·추천·상품 페이지에서 첫인상을 빠르게 만들어
          쇼핑객이 클릭해 들어올지 결정해요.
        </li>
        <li>
          상세 이미지는 쇼핑객이 '머물게' 하는 이미지예요. 판매 포인트, 사용 장면, 신뢰 형성을 통해 궁금증을 해소하고
          구매까지 이끌어 줘요.
        </li>
      </ul>

      <h3>3. 타깃 시장에 맞는 비주얼 스타일 선택</h3>
      <p>5가지 시장 스타일이 기본 제공되니 현지 미감을 직접 추측할 필요가 없어요:</p>
      <ul>
        <li>
          북미/유럽(Amazon): 브랜드 중심의 이성적·프리미엄 라이프스타일 — 절제된 레이아웃, 뛰어난 사진 퀄리티, 명확한
          정보 위계.
        </li>
        <li>일본: 감성적이고 설득력이 강한 스타일 — 굵은 헤드라인과 슬로건, 정보가 많아도 정돈된 구성.</li>
        <li>한국(Coupang): 라이프스타일 중심의 부드럽고 친근한 스타일 — 강한 장면감, 절제된 텍스트, 포근한 무드.</li>
        <li>러시아(Ozon): 전환 중심의 직접적인 설득 스타일 — 굵은 헤드라인, 강렬한 색 블록, 촘촘한 아이콘 라벨.</li>
        <li>동남아: 프로모션 느낌이 강한 비주얼 마케팅 스타일 — 생생한 색감, 뚜렷한 프로모션 분위기.</li>
      </ul>

      <h3>4. 고화질 버전 생성 전 미리보기</h3>
      <p>
        최종 생성 전에 미리보기로 결과를 확인하세요. 미리보기 비용은 <strong>0.4위안/세트</strong>에 불과해요. 결과에
        만족하면 고화질 전체 세트를 생성해 크레딧 낭비를 줄이세요.
      </p>

      <h3>5. 다운로드 및 사용</h3>
      <p>생성이 완료되면 모든 이미지를 바로 다운로드해 플랫폼의 메인 이미지와 상세 페이지 항목에 업로드하세요.</p>
    </>
  );
};

export default KoContent;
